<template>
<div
  class='slide slide-poll'
  :class="{'has-response': show_stats && selected_answer}"
>
  <div class='slide_label slide-poll_label body-four-light'>
    {{ activity.label || $t('poll') }}
  </div>

  <h2
    :id="'poll-headline-' + activity.id"
    class='slide_headline slide-poll_headline h-two-light'
  >
    {{ activity.prompt }}
  </h2>

  <!-- Desktop View -->
  <template v-if='is_desktop_view'>
    <PollMain
      :activity='activity'
      :slide_result='slide_result'
      :view_style='view_style'
      :is_desktop_view='is_desktop_view'
      :is_authenticated='is_authenticated'
      :toggleSignInOverlay='toggleSignInOverlay'
      :updateResult='updateResult'
      :updateCurrentActivity='updateCurrentActivity'
    />
  </template>

  <!-- Mobile Visual View -->
  <template v-if='view_style === "visual" && !is_desktop_view'>
    <PollMain
      :activity='activity'
      :slide_result='slide_result'
      :view_style='view_style'
      :is_desktop_view='is_desktop_view'
      :is_authenticated='is_authenticated'
      :toggleSignInOverlay='toggleSignInOverlay'
      :updateResult='updateResult'
      :updateCurrentActivity='updateCurrentActivity'
    />
  </template>

  <!-- Mobile Textual View in Overlay -->
  <template v-if='(view_style === "textual" || view_style === "scale") && !is_desktop_view'>
    <button
      class='slide-poll_link button-one-branded'
      @click='toggleOverlay'
    >
      {{ cta_button_copy }}
    </button>
  </template>
</div>
</template>

<script>
import CommonMixin from './common-mixin'
import PollMain from '../activity/activities/v1/Poll/poll-v1'

export default {
  mixins: [CommonMixin],

  props: [
    'toggleActivityOverlay',
    'updateCurrentActivity'
  ],

  components: {
    PollMain
  },

  data() {
    return {
      viewportWidth: null
    }
  },

  created() {
    this.recalculateViewportWidth()

    window.addEventListener('orientationchange', this.recalculateViewportWidth)
    window.addEventListener('resize', this.recalculateViewportWidth)
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.recalculateViewportWidth)
    window.removeEventListener('orientationchange', this.recalculateViewportWidth)
  },

  computed: {
    show_stats() {
      return this.activity.show_stats
    },

    selected_answer() {
      return (this.slide_result.results && this.slide_result.results.selected)
    },

    cta_button_copy() {
      return this.selected_answer
        ? this.$t('view_poll_results')
        : this.$t('take_poll')
    },

    view_style() {
      return this.activity.view_style
    },

    is_desktop_view() {
      if (this.viewportWidth) {
        return !(this.viewportWidth <= 768)
      }
      return null
    }
  },

  methods: {
    recalculateViewportWidth() {
      this.viewportWidth = $(window).width()
    },

    toggleOverlay() {
      if (this.is_authenticated) {
        this.toggleActivityOverlay()
      } else {
        this.toggleSignInOverlay()
      }
    }
  }
}
</script>

<style lang='sass'>
@import './poll-v1'
</style>
